// VX: "También te puede interesar" del carrito lateral (flechas, opciones y botón Añadir).
if (!customElements.get('vx-cart-upsell')) {
  customElements.define(
    'vx-cart-upsell',
    class VxCartUpsell extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-up-track]');
        const step = (dir) => this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'smooth' });
        const prev = this.querySelector('[data-up-prev]');
        const next = this.querySelector('[data-up-next]');
        if (prev) prev.addEventListener('click', () => step(-1));
        if (next) next.addEventListener('click', () => step(1));

        this.querySelectorAll('.vx-upsell__card').forEach((card) => {
          try {
            card._variants = JSON.parse(card.querySelector('[data-vx-upsell-variants]').textContent);
          } catch (e) {
            card._variants = [];
          }
          card.querySelectorAll('[data-up-option]').forEach((sel) => sel.addEventListener('change', () => this.update(card)));
          card.querySelector('[data-up-add]').addEventListener('click', (e) => this.add(card, e.currentTarget));
        });
      }

      money(cents) {
        // Mismo formato que el resto del carrito: copiamos el del precio que ya pinta Shopify
        const sample = this.querySelector('[data-up-price]');
        const txt = sample ? sample.textContent.trim() : '$0.00';
        const comma = /\d,\d{2}(\D|$)/.test(txt);
        let n = (cents / 100).toFixed(2);
        if (comma) n = n.replace('.', ',');
        return txt.replace(/[\d.,]+/, n);
      }

      selected(card) {
        const sels = Array.from(card.querySelectorAll('[data-up-option]'));
        if (!sels.length) return card._variants[0];
        const wanted = sels.map((s) => s.value);
        return card._variants.find((v) => v.options.every((o, i) => o === wanted[i])) || null;
      }

      update(card) {
        const v = this.selected(card);
        const btn = card.querySelector('[data-up-add]');
        if (!btn.dataset.label) btn.dataset.label = btn.textContent;
        if (!v) {
          btn.disabled = true;
          btn.textContent = 'No disponible';
          return;
        }
        btn.dataset.variant = v.id;
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.label : 'Agotado';
        card.querySelector('[data-up-price]').textContent = this.money(v.price);
        const cmp = card.querySelector('[data-up-compare]');
        if (v.compare > v.price) {
          cmp.textContent = this.money(v.compare);
          cmp.hidden = false;
        } else {
          cmp.hidden = true;
        }
        const img = card.querySelector('.vx-upsell__img img');
        if (img && v.image) img.src = v.image;
      }

      add(card, btn) {
        const id = Number(btn.dataset.variant);
        if (!id || btn.disabled || this.busy) return;
        this.busy = true;
        btn.classList.add('is-loading');
        const err = this.querySelector('[data-up-error]');
        if (err) err.hidden = true;
        const drawer = document.querySelector('cart-drawer');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) {
              if (err) {
                err.textContent = data.description || data.message || 'No se pudo añadir al carrito.';
                err.hidden = false;
              }
              return;
            }
            if (window.publish && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'vx-cart-upsell', cartData: data });
            }
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
            } else {
              window.location.href = root + 'cart';
            }
          })
          .catch(() => {
            if (err) {
              err.textContent = 'No se pudo añadir al carrito. Inténtalo de nuevo.';
              err.hidden = false;
            }
          })
          .finally(() => {
            this.busy = false;
            btn.classList.remove('is-loading');
          });
      }
    }
  );
}
